var TagView,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

TagView = (function() {
  function TagView(gallery_id, options) {
    this.gallery_id = gallery_id;
    this.delete_tag = __bind(this.delete_tag, this);
    this.add_tag = __bind(this.add_tag, this);
    this.open_tag_ui = __bind(this.open_tag_ui, this);
    this.open_tag = __bind(this.open_tag, this);
    this.load = __bind(this.load, this);
    this.refresh = __bind(this.refresh, this);
    this.move = __bind(this.move, this);
    ObservableArray(this, 'tags');
    ObservableArray(this, 'breadcrumb');
    this.breadcrumb.push({
      text: 'Library',
      click: (function(_this) {
        return function() {};
      })(this)
    });
    Observable(this, 'loaded', null);
    this.tagcloud = new TagCloud(this.loaded);
    History.Adapter.bind(window, 'statechange', (function(_this) {
      return function() {
        var data;
        data = History.getState().data;
        if (data.index == null) {
          return _this.refresh();
        }
      };
    })(this));
    $('#tag_title').bind('keydown', 'return', this.add_tag);
  }

  TagView.prototype.move = function(element) {
    var tag, to;
    tag = element.item;
    to = element.targetIndex;
    return tag.update({
      sort: to
    });
  };

  TagView.prototype.refresh = function(type) {
    return this.loaded(null);
  };

  TagView.prototype.load = function() {
    return FeaturedTag.find(this.gallery_id, {}, (function(_this) {
      return function(data) {
        var slug, state, tag, _i, _len, _ref;
        state = History.getState();
        slug = state.url.match(/\?\/([\w-]+)$/);
        if (slug != null) {
          slug = slug[1];
        }
        _ref = data.featured_tags;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          tag = _ref[_i];
          _this.tags.push(FeaturedTag(tag, _this.tagcloud.selected_ids));
          if (tag.slug === slug) {
            _this.open_tag(_this.tags()[_this.tags.indexOf(tag)]);
          }
        }
        data = History.getState().data;
        if (data.id != null) {
          return _this.open_tag(_this.tags()[data.index]);
        }
      };
    })(this));
  };

  TagView.prototype.open_tag = function(data, event) {
    this.breadcrumb.push({
      text: data.name,
      click: (function(_this) {
        return function() {};
      })(this)
    });
    this.tagcloud.subscribe(assetsgrid.reload);
    return this.loaded(data);
  };

  TagView.prototype.open_tag_ui = function(data, event) {
    this.open_tag(data);
    return History.pushState({
      index: this.tags.indexOf(data)
    }, data.name(), '?/' + data.slug);
  };

  TagView.prototype.add_tag = function(data, event) {
    var new_name, tag, _i, _len, _ref;
    new_name = $('#tag_title').val();
    if ('' === new_name) {
      return;
    }
    _ref = this.tags();
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      tag = _ref[_i];
      if (tag.name() === new_name) {
        return alert('This tag is already featured.');
      }
    }
    $('#tag_title').val('');
    return Tag.create(new_name, (function(_this) {
      return function(data) {
        return FeaturedTag.create(_this.gallery_id, data.id, function(data2) {
          return _this.tags.unshift(Tag(data2));
        });
      };
    })(this));
  };

  TagView.prototype.delete_tag = function(featured_tag) {
    if (confirm('Are you sure you want to unfeature this tag?')) {
      return FeaturedTag(featured_tag)["delete"]((function(_this) {
        return function() {
          console.log(featured_tag);
          return _this.tags.remove(featured_tag);
        };
      })(this));
    }
  };

  return TagView;

})();

//# sourceMappingURL=0-tags.js.map
